import { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { Country } from '@tiendanube/common/src/enums';
import { HeaderContent, HeaderTop, IonPageStratus } from 'commons/components';
import { useModal } from 'commons/hooks';
import { useGetCountry } from 'domains/Auth/hooks';
import { useGetRecipient } from 'domains/PagoNubeOnboarding/Recipient/hooks';
import useTranslationPagoNubeOnboarding from 'domains/PagoNubeOnboarding/useTranslationPagoNubeOnboarding';
import { useStoreInfo } from 'domains/PartnersApps/hooks';
import CompanyModal from './CompanyModal';
import IndividualForm from './IndividualForm/IndividualForm';
import PagoNubeOnboardingSkeleton from './PagoNubeOnboardingSkeleton';

const backNavigation = (goToBack: () => void) => ({
  onClick: goToBack,
});

function PagoNubeOnboarding() {
  const t = useTranslationPagoNubeOnboarding();

  const [stripeFormLink, setStripeFormLink] = useState<string | undefined>();
  const [showIndividualForm, setShowIndividualForm] = useState<boolean>(false);

  const history = useHistory();
  const country = useGetCountry();
  const { id: storeId } = useStoreInfo();
  const [showCompanyModal, openCompanyModal, closeCompanyModal] = useModal();

  const handleShowCompanyModal = useCallback(
    (stripeFormLink?: string) => {
      setStripeFormLink(stripeFormLink);
      openCompanyModal();
    },
    [openCompanyModal],
  );

  const {
    fetchRecipient,
    isLoading: isRecipientLoading,
    recipientData,
    resetRecipientData,
  } = useGetRecipient(handleShowCompanyModal, setShowIndividualForm);

  const goToBack = useCallback(() => {
    history.goBack();
  }, [history]);

  useEffect(() => {
    if (storeId && !recipientData) {
      fetchRecipient(storeId);
    }
    return () => {
      if (recipientData) resetRecipientData();
    };
  }, [fetchRecipient, recipientData, resetRecipientData, storeId]);

  return (
    <IonPageStratus
      headerTop={<HeaderTop navigation={backNavigation(goToBack)} />}
      headerContent={
        <HeaderContent title={t('title')} subtitle={t('subtitle')} />
      }
      width="small"
    >
      {isRecipientLoading ? (
        <PagoNubeOnboardingSkeleton />
      ) : (
        <>
          {showIndividualForm && <IndividualForm />}
          {country === Country.MX && showCompanyModal && (
            <CompanyModal
              closeModal={closeCompanyModal}
              showModal={showCompanyModal}
              stripeFormLink={stripeFormLink || ''}
            />
          )}
        </>
      )}
    </IonPageStratus>
  );
}

export default PagoNubeOnboarding;
